export default "__VITE_ASSET__CHb6uvyh__"